<template>
  <translations-tabs>
    <template #default="{language}">
      <v-card>
        <v-card-title class="py-1">
          <h4>{{ $t('Variant Options') }}</h4>

          <v-spacer/>

          <v-btn
            v-if="!language || (language && language.default)"
            flat
            class="text--secondary text-capitalize"
            @click="addOption"
          >
            {{ $t('Add option') }}
          </v-btn>
        </v-card-title>

        <v-divider/>

        <v-card-text>
          <translatable-collection
            v-model="product"
            :language="language"
            :item-component="VariantComponent"
            :creating="creating"
            field-name="variants"
            no-items-text="No Variants"
            @created="creating = false"
            @removed="removeOption"
          />
        </v-card-text>

        <v-divider/>

        <v-card-actions v-if="product.variants && product.variants.length">
          <v-spacer/>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="product.id"
                flat
                class="text--secondary text-capitalize"
                v-on="on"
                @click="updateVariants"
              >
                {{ $t('Update Variants') }}
              </v-btn>
            </template>
            <span>{{ $t('Updates Variations based on Options changes, without re-creating unaffected Variations. Will not add and generate new Variant set.') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="product.id"
                flat
                class="text--secondary text-capitalize"
                v-on="on"
                @click="generateVariants"
              >
                {{ $t('Generate Variants') }}
              </v-btn>
            </template>
            <span>{{ $t('Regardless of the changes in Variants, it will always re-create all the Variations based on current Variants options.') }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </template>
  </translations-tabs>
</template>

<script>
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import ProductVariant from '@/modules/Products/components/ProductVariant'
import TranslatableCollection from '@/components/widgets/TranslatableCollection'
import PressableButton from '@/components/widgets/PressableButton'

export default {
  name: 'ProductSingleOptions',
  components: { PressableButton, TranslatableCollection, TranslationsTabs, ProductVariant },

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      creating: false,
      VariantComponent: ProductVariant
    }
  },

  methods: {
    addOption () {
      if (this.product.variants === null) {
        this.product.variants = []
      }

      this.creating = true
    },

    async generateVariants () {
      this.product.createVariants(this.prepareVariants()).then(() => {
        this.$toast.success(this.$t('Variants generated'))
      }).catch(e => {
        this.$toast.error(this.$t(e.message))
      })
    },

    async updateVariants () {
      this.product.updateVariants(this.prepareVariants()).then(() => {
        this.$toast.success(this.$t('Variants updated'))
      }).catch(e => {
        this.$toast.error(this.$t(e.message))
      })
    },

    prepareVariants () {
      const isNumber = value => !isNaN(parseFloat(value)) && isFinite(value)

      this.product.variants = Object.values(this.product.variants)
      let variants = this.product.variants.filter(v => !!v.name).filter(v => !!v.options)
      return variants.map(v => {
        v.options = v.options.map(o => {
          return isNumber(o) ? Number(o) : o
        })

        return v
      })
    },

    async removeOption (variant) {
      if (!variant || variant.isNew) {
        return
      }

      try {
        await this.product.deleteOption(variant)
        await this.product.refresh()
        this.$toast.success(this.$t('Option deleted'))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
